import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationDetails } from 'src/app/models/reports/OrganizationDetails';
import { ReportService } from 'src/app/services/report.service';
import html2canvas from 'html2canvas';
import { GatePassDetails } from 'src/app/models/reports/GatePassDetails';

@Component({
  selector: 'app-gate-pass-print',
  templateUrl: './gate-pass-print.component.html'
})
export class GatePassPrintComponent implements OnInit {
  dataLoading = false;
  Doc_ID!: number;
  VisitType!: string;
  details: OrganizationDetails = new OrganizationDetails();
  gatePassDetails: GatePassDetails = new GatePassDetails();
  QrCode!: string;

  constructor(
    private service: ReportService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('Doc_ID')) {
        this.Doc_ID = Number(params.get('Doc_ID'));
      }
      if (params.get('VisitType')) {
        this.VisitType = params.get('VisitType')!;
      }
      this.getOrganizationDetails();
      this.getGatePassReport();
    });
  }

  getOrganizationDetails() {
    this.dataLoading = true;
    this.service.getOrganizationDetails().subscribe(
      (data) => {
        if (data) {
          this.details = data as OrganizationDetails;
        }
      },
      error => {
        this.dataLoading = false;
      });
  }

  getGatePassReport() {
    const query = {
      Doc_ID: this.Doc_ID,
      VisitType: this.VisitType
    };
    this.dataLoading = true;
    this.service.getGatePassReport(query).subscribe(
      (data) => {
        if (data) {
          this.dataLoading = false;
          this.gatePassDetails = data as GatePassDetails;
          this.QrCode = decodeURIComponent(String(this.gatePassDetails.gatePassID));
        }
      },
      error => {
        this.dataLoading = false;
      });
  }

  printPage() {
    window.print();
  }

  printPageAsPdf() {
    let data = document.getElementById("element-to-print");
    // let data = document.getElementById("maindiv");
    html2canvas(data!).then(canvas => {
      // console.log(canvas)
      // this.pdfTable.appendChild(canvas);
      // const contentDataURL = canvas.toDataURL('image/jpeg', 1.0)
      // // let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
      // let pdf = new jspdf('p', 'cm', 'a4'); //Generates PDF in portrait mode
      // pdf.addImage(contentDataURL, 'jpg', 0, 0, 29.7, 21.0);
      // pdf.save('Filename.pdf');
    });
  }
}
